import script from "./AnnualReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualReportView.vue?vue&type=script&setup=true&lang=js"

import "./AnnualReportView.vue?vue&type=style&index=0&id=2ce817cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce817cf"]])

export default __exports__